module.exports = __webpack_public_path__ + "img/image-7.0dc5fa44.webp";